<template>
  <div class="flex items-center" :title="text">
    <Icon
      :icon="icon || defaultIcon"
      :class="iconClass || defaultIconClass"
      class="mr-1 fill-current"
    />
    <div
      :class="textClass || defaultTextClass"
      class="text-xs font-medium tracking-wide uppercase"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
  import Icon from "@/core/components/Icon"

  export default {
    name: "IconBadge",
    components: {
      Icon,
    },
    props: {
      icon: {
        type: String,
        default: null,
      },
      iconClass: {
        type: String,
        default: null,
      },
      textClass: {
        type: String,
        default: null,
      },
      text: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        success: [
          "autenticado",
          "finished",
          "executed",
          "finalizado",
          "executado",
          "pago",
          "ativo",
          "ativa",
          "vínculo ativo",
          "suspenso judicialmente",
          "remitido (covid-19)",
          "impresso",
          "impressa",
          "definitivo",
          "aprovado",
          "resolvido",
          "resolução enviada",
        ],
        error: [
          "failed",
          "issue",
          "falhou",
          "com problemas",
          "com pendências",
          "rejeitado",
          "negado",
          "em cancelamento",
          "cancelado",
          "cancelada",
          "inválido",
          "suspenso",
          "inativo",
          "vencido",
          "vencida",
          "vínculo inativo",
          "vínculo rejeitado",
          "faltando cnd",
          "bloqueado",
        ],
        waiting: [
          "pending",
          "pendente",
          "solicitado",
          "vínculo solicitado",
          "provisório",
          "cadastro incompleto",
          "aguardando pagamento",
          "aguardando documentação",
          "aguardando validação",
          "aguardando validação manual",
          "sujeito a verificação",
          "aguardando envio ao sgpe",
          "aguardando ativação no sgpe",
          "aguardando aprovação",
        ],
        attention: ["aberto", "em aberto"],
        high: ["high", "alta", "alto"],
        medium: ["medium", "normal"],
        low: ["low", "baixa", "baixo"],
      }
    },
    computed: {
      defaultIcon() {
        if (this.icon) {
          return null
        }
        const textLower = this.text.toLowerCase()
        if (this.error.includes(textLower)) {
          return "close"
        }
        if (this.success.includes(textLower)) {
          return "checkedCircle"
        }
        if (this.waiting.includes(textLower)) {
          return "clock"
        }
        if (this.attention.includes(textLower)) {
          return "exclamation"
        }
        if (this.high.includes(textLower)) {
          return "arrowUp"
        }
        if (this.medium.includes(textLower)) {
          return "arrowUp"
        }
        if (this.low.includes(textLower)) {
          return "arrowDown"
        }
        return "config"
      },
      defaultIconClass() {
        if (this.iconClass) {
          return null
        }
        const textLower = this.text.toLowerCase()
        if (this.error.includes(textLower)) {
          return "h-4 text-red-text"
        }
        if (this.success.includes(textLower)) {
          return "h-4 text-green-600"
        }
        if (this.waiting.includes(textLower)) {
          return "h-4 text-orange-600"
        }
        if (this.attention.includes(textLower)) {
          return "h-4 text-red-text"
        }
        if (this.high.includes(textLower)) {
          return "h-2 text-red-text"
        }
        if (this.medium.includes(textLower)) {
          return "h-2 text-gray-dark"
        }
        if (this.low.includes(textLower)) {
          return "h-2 text-green-600"
        }
        return "h-4 text-gray-darker"
      },
      defaultTextClass() {
        if (this.textClass) {
          return null
        }
        const textLower = this.text.toLowerCase()
        if (this.error.includes(textLower)) {
          return "text-red-text"
        }
        if (this.success.includes(textLower)) {
          return "text-green-600"
        }
        if (this.waiting.includes(textLower)) {
          return "text-orange-600"
        }
        if (this.attention.includes(textLower)) {
          return "text-red-text"
        }
        if (this.high.includes(textLower)) {
          return "text-red-text"
        }
        if (this.medium.includes(textLower)) {
          return "text-gray-dark"
        }
        if (this.low.includes(textLower)) {
          return "text-green-600"
        }
        return "text-gray-darker"
      },
    },
  }
</script>
